import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import router from './router';
import { refreshTokenIsValid, tokenIsValid } from './services/utils';

const whiteList = ['/login']; // no redirect whitelist

router.beforeEach(
  async (
    to: RouteLocationNormalized,
    _: RouteLocationNormalized,
    next: NavigationGuardNext,
  ) => {
    if (tokenIsValid() || refreshTokenIsValid()) {
      if (to.path === '/login') {
        // if is logged in, redirect to the home page
        next({ path: '/admin' });
      } else {
        next();
      }
    } else {
      /* has no token*/

      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly
        next();
      } else {
        next(`/login`);
      }
    }
  },
);
